import { createI18n } from 'vue-i18n';

const langFiles = require.context('./translations', true, /\.json$/);

const translations = langFiles.keys().reduce((accumulator, filePath) => {
  const langName = filePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const fileContent = langFiles(filePath);

  accumulator[langName] = fileContent;

  return accumulator;
}, {});

const defaultLocale = process.env.VUE_APP_DEFAULT_I18N_LOCALE || 'en';

const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: translations,
});

export default i18n;
